import $http from '@/api';

interface HintContext {
  field: string,
  value: any,
  entity: string,
  entityId: number,
}

export function fetchComponentHint(hintEndpoint: string, hintContext: HintContext): Promise<{ hint: string }> {
  return $http.post(hintEndpoint, hintContext);
}

export default {
  fetchComponentHint,
};
